// Popup.
export const SHOW_POPUP = "SHOW_POPUP";
export const HIDE_POPUP = "HIDE_POPUP";
export const UPDATE_POPUP = "UPDATE_POPUP";
